var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCameraNoAccess = function SvgIconCameraNoAccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8C9 7.44772 9.44772 7 10 7H16C16.5523 7 17 7.44772 17 8V14C17 14.5523 16.5523 15 16 15H10C9.44772 15 9 14.5523 9 14V8Z",
    fill: "#F84E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0C0.447715 0 0 0.447716 0 1V9C0 9.55229 0.447715 10 1 10H7V8C7 6.34315 8.34315 5 10 5H16V1L11 3.85714V1C11 0.447715 10.5523 0 10 0H1Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8536 8.14648L13.0001 10.293L15.1466 8.14648L15.8537 8.85359L13.7072 11.0001L15.8536 13.1465L15.1465 13.8536L13.0001 11.7072L10.8537 13.8536L10.1466 13.1465L12.293 11.0001L10.1465 8.85359L10.8536 8.14648Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCameraNoAccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-camera-no-access.eb07d811.svg";
export { ForwardRef as ReactComponent };